module.exports = __webpack_public_path__ + "tooltip-nubbin.f51a0f52090475e891b9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/images/tooltip-nubbin.svg
// module id = 1489
// module chunks = 2